import faker from 'faker'

export { faker as $$faker }
